/* eslint-disable react/no-array-index-key */
import React from 'react';
import { getDateTime } from '../../utils/common';
import EventDetailsTable from './EventDetailsTable';

const EventsTable = ({
  goals, getTimezone, eventType, markets,
}) => {
  if (goals?.length > 0) {
    return goals.map((goal, i) => {
      const goalTime = getDateTime(goal.dateTime, getTimezone).split(' ')[1].replace(/:/g, ' : ');
      return (
        <tr key={`${goal.matchMinute}-${goal.dateTime}-${goal.homeScore}-${goal.awayScore}-${i}`}>
          <td>{goalTime}</td>
          <EventDetailsTable
            goal={goal}
            eventType={eventType}
            markets={markets}
          />
          <td />
        </tr>
      );
    });
  }
  return null;
};

export default EventsTable;
